import { render } from "./Examples.vue?vue&type=template&id=25babd2a&ts=true"
import script from "./Examples.vue?vue&type=script&lang=ts"
export * from "./Examples.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__